// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"a500fe00","453":"3d23a748","949":"9539f02c"}[chunkId] + ".chunk.js";
};